import { render, staticRenderFns } from "./skillsChart.vue?vue&type=template&id=6329ef3c&scoped=true"
import script from "./skillsChart.vue?vue&type=script&lang=js"
export * from "./skillsChart.vue?vue&type=script&lang=js"
import style0 from "./skillsChart.vue?vue&type=style&index=0&id=6329ef3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6329ef3c",
  null
  
)

export default component.exports